//todo: remove file once old domain is deleted
import React, { ReactNode } from 'react';
import {
    FGBannerAlert,
    FGLayout,
    FGLink,
    FGToastContainer,
} from '@fg/design-system';
import { APP_DOMAIN } from 'services/configService';
import Footer from 'Footer';
import Header from 'Header';
import Sidebar from 'Sidebar';
import GQPopupManager from './GQPopup/GQPopupManager';

const NEW_APP_URL = `https://app.${APP_DOMAIN}`;

type Props = { children: ReactNode };
const DomainMigrationLayout = React.memo((props: Props) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
            }}>
            <FGBannerAlert type="warning">
                We've moved to{' '}
                <FGLink
                    href={NEW_APP_URL}
                    style={{ color: 'inherit', textDecoration: 'underline' }}>
                    {NEW_APP_URL}
                </FGLink>{' '}
                – please update your bookmarks.
            </FGBannerAlert>
            <div style={{ flex: 1, minHeight: 0 }}>
                <FGLayout
                    footer={<Footer />}
                    header={<Header />}
                    sidebar={<Sidebar />}>
                    <GQPopupManager />
                    <FGToastContainer />
                    <div style={{ height: '100%' }}>{props.children}</div>
                </FGLayout>
            </div>
        </div>
    );
});

export default DomainMigrationLayout;
